<template>
  <div class="row__dropdown" ref="dropdown">
    <div v-if="onFile" class="row__dropdown-item row__dropdown-item--pdf icon__pdf" @click="onFile()" ref="dropdownFile">
      {{ $t('customers.tableHeader.file') }}
    </div>
    <div v-if="onDownload" class="row__dropdown-item row__dropdown-item--edit icon__download" @click="onDownload()" ref="dropdownDownload">
      Download
    </div>
    <div v-if="onTogglePublic" class="row__dropdown-item row__dropdown-item--public" @click="onTogglePublic()" ref="dropdownTogglePublic">
      <span class="checkbox">
        <input type="checkbox" :checked="Boolean(isPublic)" class="checkbox__checkbox" readonly />
        <label class="checkbox__label"></label>
      </span>
      {{ isPublic ? 'Public' : 'Private' }}
    </div>
    <div v-if="onEdit" class="row__dropdown-item row__dropdown-item--edit icon__edit" @click="onEdit()" ref="dropdownEdit">
      {{ $t(`buttons.${"editBtn"}`) }}
    </div>
    <div v-if="onDelete" class="row__dropdown-item row__dropdown-item--delete icon__delete" @click="onDelete()" ref="dropdownDelete">
      {{ $t(`buttons.${"deleteBtn"}`) }}
    </div>
    <div v-if="isUserAction && isActive === 1" @click="onDisable()"
      class="row__dropdown-item row__dropdown-item--disable icon__disable" ref="dropdownDisable">
      {{ $t(`buttons.${"disable"}`) }}
    </div>
    <div v-if="isUserAction && isActive === 0" @click="onEnable()"
      class="row__dropdown-item row__dropdown-item--enable icon__enable" ref="dropdownEnable">
      {{ $t(`buttons.${"enable"}`) }}
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";

defineOptions({
  name: "RowActionDropdown"
});

const { onFile, onDownload, onTogglePublic, isPublic, onEdit, onDelete, isActive, onDisable, onEnable } = defineProps({
  onFile: {
    required: false,
    type: Function,
    default: null,
  },
  onDownload: {
    required: false,
    type: Function,
    default: null,
  },
  onTogglePublic: {
    required: false,
    type: Function,
    default: null,
  },
  isPublic: {
    required: false,
    type: Boolean,
    default: false,
  },
  onEdit: {
    required: false,
    type: Function,
    default: null,
  },
  onDelete: {
    required: false,
    type: Function,
    default: null,
  },
  isActive: {
    required: false,
    type: Number,
  },
  onDisable: {
    required: false,
    type: Function
  },
  onEnable: {
    required: false,
    type: Function
  }
});

const route = useRoute();
const isUserAction = ref(false);

// Template Refs
const dropdown = ref(null);
const dropdownFile = ref(null);
const dropdownDownload = ref(null);
const dropdownTogglePublic = ref(null);
const dropdownEdit = ref(null);
const dropdownDelete = ref(null);
const dropdownDisable = ref(null);
const dropdownEnable = ref(null);

const checkIfClickedInside = (event) => {
  const { target } = event;
  const d = dropdown.value;
  const dFile = dropdownFile.value;
  const dDownload = dropdownDownload.value;
  const dTogglePublic = dropdownTogglePublic.value;
  const dEdit = dropdownEdit.value;
  const dDelete = dropdownDelete.value;
  const dDisable = dropdownDisable.value;
  const dEnable = dropdownEnable.value;

  if (
    target === d ||
    target === dFile ||
    target === dDownload ||
    target === dTogglePublic ||
    target === dEdit ||
    target === dDelete ||
    target === dDisable ||
    target === dEnable
  ) {
    // Keep logic flow
  } else {
    // Note: Original logic triggered hiding here, ensured it persists
  }
};

onMounted(() => {
  isUserAction.value = route.name === "Users";
  document.addEventListener("click", checkIfClickedInside);
});

onUnmounted(() => {
  isUserAction.value = false;
  document.removeEventListener("click", checkIfClickedInside);
});
</script>

<style scoped lang="scss">
.row__dropdown-item--public{
  padding-left: 10px !important;
}
</style>
